import React from 'react'

let url              				 = process.env.PUBLIC_URL;
let type_server              = 1;

/* ---> Live Server --*/
let base_url 						     = 'https://specials.target-healthcare.co.uk'

/* ---> Test Server --*/
//let base_url 						   = 'https://specials-test.target-healthcare.co.uk'


let redirect_url             = base_url+'/admin'
let report_url        			 = base_url+'/api/mpdf/reports'
let route 									 = '/admin/'
let isreport                 = false


/*-----------------------------------------------
  UNLIVE UPDATE / PENDING UPDATE TO LIVE SERVER
  * Processing Notes
-----------------------------------------------*/
let unliveUpdate               = false
if(type_server==1){
    unliveUpdate               = true
}


export function UnliveUpdateFunction() {
	return unliveUpdate;
}

export function TypeServerOnline() {
	return type_server;
}


export function RouteURL(props) {
	return route+props;
}


export function BaseURL(){
	return base_url;
}

export function WindowLocationBaseUrl(props) {
	return base_url+props;
}


export function WindowReload(props){
   return window.location.reload();
}

export function WindowURL(props) {
	return url+props;
}


export function RedirectURL(props) {
	return redirect_url+props;
}


export function WindowLocation(props) {
	return window.location.href = url+props;
}

export function ReportsMPDFUrl(props) {
	return report_url+props;
}

export function ActiveMenu(props){
   let path = window.location.pathname;
   var url=path.split('/');
   const found = url.find(element => element === props);
   if(found==props){
     return true;
   }else{
     return false;
   }
}

export function ReportsDev(){
	return isreport;
}


export function CurrencySymbol(){
  return '£';
}